import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import './OrderSummary.css'
import BaseURL from "../Util/BaseURL";
function GetProductName(props) {
  const [data, setData] = useState([]);
  const [cart,setCart] = useState()
  const [products, setProducts] = useState();
    const [quantity, setQuantity]=useState()
    const [price,setPrice]=useState()
    const [total,setTotal]=useState()
    const [pro,setPro] = useState()
  var nav = useNavigate()
  function navigate(props) {
      nav('/Products', { state: { productId: props} })
  }

  const getData = async()=>{
       const res=await axios.get(`${BaseURL}getProduct?id=${props.props}`)
          setData(res.data);
        }
        useEffect(() => {
          getData();
        }, []);
  return (
    <>
       <span className="protitle" style={{textAlign:"center"}} onClick={()=>navigate(data.productId)}>{data.title}</span>
    </>
  );
}
export default GetProductName
